import { ImporteBodyTemplate } from "features/Documentos/templates"
import { TFunction } from "i18next"
import { frontendDateFormat } from "utils/formatDate"

interface PagosCobrosFooterProps {
  t: TFunction
  importePendiente: number
  startDate: Date | undefined
  endDate: Date | undefined
}

const PagosCobrosFooter = ({
  t,
  importePendiente,
  startDate,
  endDate,
}: PagosCobrosFooterProps) => {
  return (
    <div
      data-testid='footer-tabla-pagos-cobros'
      className={`tw-flex tw-flex-row tw-items-center tw-bg-white tw-px-5 tw-py-4 ${
        startDate ? "tw-justify-between" : "tw-justify-end"
      }`}
    >
      {startDate && (
        <span className='tw-flex tw-text-base tw-font-medium tw-gap-2'>
          <p>{t("pagoCobro.labelDate")}</p>
          <span>
            {startDate && frontendDateFormat(startDate)}
            {endDate && ` - ${frontendDateFormat(endDate)}`}
          </span>
        </span>
      )}
      <span className='tw-flex tw-text-lg tw-font-medium tw-gap-2'>
        {t("pagoCobro.labelTotal")}
        <ImporteBodyTemplate
          importe={importePendiente?.toFixed(2)}
          showDivisaSymbol={false}
        />
      </span>
    </div>
  )
}

export default PagosCobrosFooter
